import { useEffect, useRef } from 'react';

function usePreviousState(stateValue) {
  const ref = useRef();

  useEffect(() => {
    ref.current = stateValue;
  });

  return ref.current;
}

export { usePreviousState };
